export default __webpack_public_path__ + "static/img/lens-arrow-mobile.c922d19.svg";